// Paths where no dialog may open on its own: /login still wears the login palette, and
// verification is a flow to finish first. Shared by the passkey prompt and the install offer.
const PROMPT_SKIP_PATHS = [
    "/login",
    "/register",
    "/forgot-password",
    "/verify-email",
    "/auth/callback",
    "/account-verification",
];

export const isPromptSkipPath = (pathname = "") => PROMPT_SKIP_PATHS.some((path) => pathname.startsWith(path));

export default PROMPT_SKIP_PATHS;
